export enum Roles {
  GridCell = "gridcell",
  Option = "option",
  Row = "row",
  Tab = "tab",
  ColumnHeader = "columnheader",
  RowHeader = "rowheader",
  TreeItem = "treeitem",
  Checkbox = "checkbox",
  MenuItemCheckbox = "menuitemcheckbox",
  Radio = "radio",
  MenuItemRadio = "menuitemradio",
}
